/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import _ from 'lodash';

// custom component import
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';

import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
// custom function import
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

import { tableGridHight330 } from '../../../../SharedModules/CommonConstants/commonConstants';
import systemReminderGirdHead from './gridComponents/tableHead';
import { getSystemReminderGridList } from '../store/Actions';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import showPreloader from '../../../../interceptor/store/Actions';

function SystemReminderComponent() {
  const dispatch = useDispatch();
  // dispatch function
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.SystemReminderReducer?.errorMessagesInRedux
  );
  const systemReminderGridList = useSelector(
    (state) => state?.sharedState?.SystemReminderReducer?.systemReminderList
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  // variable deceleration
  const gridRef = React.useRef();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  // on scroll default top level
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);

  // set Initial state values
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));

    if (
      (systemReminderGridList?.length === 0 && logInUser) ||
      updateTabs?.filter((x) => {
        return x.navTo === '/reminderRecipients';
      }).length > 0
    ) {
      const obj = {
        userId: logInUser,
      };
      dispatch(getSystemReminderGridList(obj));
      if (
        updateTabs?.filter((x) => {
          return x.navTo === '/reminderRecipients';
        }).length > 0
      ) {
        dispatch(showPreloader(false));
      }
    }
  }, []);

  // handing  full screen view function
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux?.length > 0) {
      tabHighLigther('/systemReminders', true);
    } else {
      tabHighLigther('/systemReminders', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);

  return (
    <div data-testid="system-reminders">
      <div className="tabs-container">
        <div className="tBillPanel custom-check">
          <div className="paneldevider-line">
            <Spinner load={spinnerLoader} />
            <div className="panel">
              {!fullScreenView && (
                <>
                  <CustomSeparator
                    parent1="System"
                    parent2="System Reminders"
                  />
                  <DisplayErrorMessages
                    errorMessages={[
                      ...new Set(
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) => l)
                          : []
                      ),
                    ]}
                  />
                </>
              )}
            </div>
            <div
              id="testGrid"
              className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk"
            >
              <TableGrid
                ref={gridRef}
                gridHeight={fullScreenView ? '70vh' : tableGridHight330}
                rowData={systemReminderGridList}
                columnDefs={systemReminderGirdHead}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                exportFile
                helpMessage=""
                data-testid="system-reminder-grid"
                fileName="System Reminders"
                singleClickEdit
                suppressCellFocus
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                onCellFocused={onCellFocused}
                frameworkComponents={{
                  DescriptionCellRender: (cellInfo) => {
                    const name = cellInfo?.data?.reminderName;
                    if (name && name.length > 40) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SystemReminderComponent;
